module.exports = __webpack_public_path__ + "img/Group-4736.07ba6398.svg";